import { Button } from "@chakra-ui/button";
import { Badge, Box } from "@chakra-ui/layout";
import React from "react";
import theme from "../../helpers/theme";

export const ClubCard = ({ property }) => {
	return (
		<Box
			w="xs"
			borderWidth="1px"
			borderRadius="lg"
			overflow="hidden"
			userSelect="none"
			m="0.6rem"
			transition="box-shadow 200ms"
			_hover={{
				cursor: "pointer",
				boxShadow: "0 2px 5px -1px gray",
			}}
			_focus={{
				cursor: "pointer",
				boxShadow: "0 2px 5px -1px gray",
			}}
		>
			<Box h="200" w="100%" bg={`url(${property.imageUrl})`}></Box>

			<Box p="6">
				<Box d="flex" alignItems="baseline">
					{property.badges && property.badges.length === 1 ? (
						<Badge
							borderRadius="full"
							px="2"
							mr="2"
							colorScheme="teal"
						>
							badge
						</Badge>
					) : property.badges && property.badges.length > 1 ? (
						<>
							<Badge
								borderRadius="full"
								px="2"
								mr="2"
								colorScheme="teal"
							>
								{property.badges[0]}
							</Badge>
							<Badge
								borderRadius="full"
								px="2"
								mr="2"
								colorScheme="pink"
							>
								{property.badges[1]}
							</Badge>
						</>
					) : (
						<Badge
							borderRadius="full"
							px="2"
							mr="2"
							colorScheme="blue"
						>
							New
						</Badge>
					)}
					<Box
						color="gray.500"
						fontWeight="semibold"
						letterSpacing="wide"
						fontSize="xs"
						textTransform="uppercase"
						ml="2"
					>
						{property.members.length} Members
					</Box>
				</Box>
				<Box
					mt="3"
					fontWeight="semibold"
					as="h4"
					lineHeight="tight"
					isTruncated
				>
					{property.title}
				</Box>

				<Box
					d="flex"
					mt="5"
					alignItems="center"
					justifyContent="space-between"
				>
					{property.verified ? (
						<Badge
							borderRadius="full"
							px="2"
							mr="2"
							colorScheme="green"
						>
							verified
						</Badge>
					) : (
						<Badge
							borderRadius="full"
							px="2"
							mr="2"
							colorScheme="gray"
						>
							unverified
						</Badge>
					)}
					<Button
						colorScheme={theme.colours.accent}
						variant="ghost"
						rounded="full"
						size="sm"
					>
						View Club &gt;
					</Button>
				</Box>
			</Box>
		</Box>
	);
};
